import { AxiosResponse } from 'axios';
import FormattedVehicle from '../models/FormattedVehicle';
import AppConstants from '../constants/AppConstants';
import EnumService from './EnumService';
import { FleetIoExecuteQueryReq, VehicleIssueRes, VehicleReq, VehicleRes, VehicleResPage } from '../proxy/proxy';
import { AxiosFleetIoClient, AxiosVehiclesClient } from '../proxy/ProxyClients';

const FleetIoService = {
  fleetIoPage: (payload: FleetIoExecuteQueryReq) => AxiosFleetIoClient.execute(payload).then((resp) => resp)
};

export default FleetIoService;
